const aussiehomeloans = {
  loanPurpose: {
    other: 'Unfortunately Aussie can only handle home loan related enquiries at this stage',
    studentLoan: `Unfortunately Aussie is not able to handle student loan related
    enquiries at this stage`,
  },
};

const ERROR_MESSAGES = {
  aussiehomeloans,
};

export default ERROR_MESSAGES;
